import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import { Grid, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { incrementCartItems } from "../../store/actions/cartActions";

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: 20,
    background: "white",
    marginTop: 30,
    marginBottom: 100
  },
  cardRoot: {
    width: "90%",
    margin: "0 auto",
    marginTop: 20
  },
  image: {
    width: 300,
    height: 300,
    margin: "0 auto",
    marginTop: 20
  },
  CardContent: {
    margin: "0 auto",
    textAlign: "center",
    padding: 0
  },
  name: {
    color: "#cc2b33",
    fontSize: 20,
    fontWeight: 500,
    height: 25,
    padding: 5,
    marginBottom: 25
  },
  price: {
    color: "#222",
    lineHeight: 2,
    fontSize: 14,
    fontWeight: 800,
    padding: 10
  },
  description: {
    color: "#222",
    lineHeight: 2,
    fontSize: 14,
    fontWeight: 500,
    padding: 10
  },
  reset: {
    width: 120,
    fontSize: 14,
    fontWeight: 600,
    color: "white",
    padding: 10
  },
  addToCart: {
    width: 120,
    marginLeft: 20,
    color: "white",
    padding: 10
  }
}));

function ProductDetails(props) {
  let item = props.product;

  if (item) {
  }
  let incrementCart = props.incrementCart;
  let storedItems = JSON.parse(localStorage.getItem("cartItems")) || [];
  const [cartValue, setCartValue] = useState(storedItems);
  const classes = useStyles();
  let domain = "products/";
  let imageLink = domain + item.code + ".png";
  let updatedAmountAvailable = 0;
  const [amountAvailable, setAmountAvailable] = useState(item.amountAvailable);
  let amountInCart = 0;
  let alreadyInCart = false;

  const updateCartItemCount = cartItems => {
    cartItems.forEach(i => {
      if (i.name === item.name) {
        i.count++;
        alreadyInCart = true;
      }
    });
  };

  const addToCart = () => {
    let counter = Number(localStorage.getItem("cartCounter"));
    const cartItems = cartValue.slice();
    let cartItem = cartItems.filter(i => i.name === item.name);

    if (cartItem.length > 0) {
      amountInCart = cartItem[0].count || 0;
    } else amountInCart = 0;

    if (amountInCart > 0) alreadyInCart = true;

    if (amountAvailable - amountInCart > 0) {
      updatedAmountAvailable = amountAvailable - amountInCart; //decrease amount available
      setAmountAvailable(updatedAmountAvailable);
      updateCartItemCount(cartItems);

      if (!alreadyInCart) {
        cartItems.push({ ...item, count: 1 });
      }

      setCartValue(cartItems);
      counter++;
      localStorage.setItem("cartCounter", counter);
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
      incrementCart(counter, cartItems);
    } else {
      alert("Cant add more than available");
    }
  };

  return (
    <div className={classes.root}>
      <Card className={classes.cardRoot} elevation={0}>
        <CardMedia
          className={classes.image}
          image={imageLink}
          title={item.name}
        />

        <CardContent className={classes.CardContent}>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.name}
          >
            {item.name}
          </Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.price}
          >
            R{item.price}
          </Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.description}
          >
            {item.description}
          </Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.amountAvailable}
          >
            In Stock : {item.amountAvailable}
          </Typography>
        </CardContent>
      </Card>

      <Grid container justify="center" style={{ marginTop: "30px" }}>
        <Button
          className={classes.reset}
          variant="contained"
          style={{ textTransform: "none", backgroundColor: "#cc2b33" }}
          component={Link}
          to="../"
        >
          Back
        </Button>

        <Button
          className={classes.addToCart}
          variant="contained"
          style={{ textTransform: "none", backgroundColor: "green" }}
          onClick={addToCart}
        >
          Add to Cart
        </Button>
      </Grid>
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  incrementCart: (counter, items) => {
    dispatch(incrementCartItems(counter, items));
  }
});

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  const inventory = state.firestore.data.inventory;
  const product = inventory ? inventory[id] : null;

  return {
    product: product,
    cart: state.cart
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  firestoreConnect([{ collection: "inventory" }])
)(ProductDetails);
